import {
    SearchOverlayContainer as SourceSearchOverlayContainer,
    mapDispatchToProps
} from 'SourceComponent/SearchOverlay/SearchOverlay.container';
import { connect } from 'react-redux';
import { SEARCH_CHAR_THRESHOLD } from './SearchOverlay.config';

export const mapStateToProps = state => ({
    searchResults: state.SearchBarReducer.productsInSearch,
    categoriesResults: state.SearchBarReducer.categoriesInSearch,
    pagesResults: state.SearchBarReducer.pagesInSearch,
    isLoading: state.SearchBarReducer.isLoading
});

export class SearchOverlayContainer extends SourceSearchOverlayContainer {
    containerFunctions = {
        getProductLinkTo: this.getProductLinkTo.bind(this),
        makeSearchRequest: this.makeSearchRequest.bind(this),
        getCategoryLinkTo: this.getCategoryLinkTo.bind(this),
        getPageLinkTo: this.getPageLinkTo.bind(this)
    };

    makeSearchRequest() {
        const {
            makeSearchRequest,
            clearSearchResults,
            searchCriteria
        } = this.props;

        if (searchCriteria.length > SEARCH_CHAR_THRESHOLD) {
            clearSearchResults();

            makeSearchRequest({
                search: searchCriteria
            });
        }
    }

    getProductLinkTo(product) {
        const { url_key } = product;

        if (!url_key) {
            return {};
        }

        return {
            pathname: `/${url_key}`
        };
    }

    getCategoryLinkTo(category) {
        const { url_path } = category;

        if (!url_path) {
            return {};
        }

        return {
            pathname: `/${url_path}`
        };
    }

    getPageLinkTo(page) {
        const { identifier } = page;
        return {
            pathname: identifier
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchOverlayContainer);
